module.exports = __webpack_public_path__ + "img/auth-back.8a8b6974.jpg";